/**
 * Copyright 2023-2024 Highway9 Networks Inc.
 */

/**
 * Triggers a simple URL-based file download in the browser.
 * Mirrors the common inline pattern used across the app.
 */
export function downloadFile(url: string, fileName?: string): void {
  if (!url) return;

  const link = document.createElement("a");
  link.href = url;
  if (fileName) {
    link.setAttribute("download", fileName);
  }
  link.click();
}

/**
 * Triggers a download for Blob content with an explicit filename.
 */
export function downloadBlobFile(blob: Blob, fileName: string): void {
  const href = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = href;
  link.setAttribute("download", fileName);
  link.click();
  URL.revokeObjectURL(href);
}
